export const handleRegisterError = (error: any): never => {
  // New API format: { status: 4xx, errors: { field: "message" } }
  const errorsObj = error.response?.data?.errors;
  let errorMessage: string;

  if (errorsObj && typeof errorsObj === 'object') {
    const firstValue = Object.values(errorsObj)[0];
    errorMessage = typeof firstValue === 'string' ? firstValue : 'An error occurred during the registration process.';
  } else {
    errorMessage =
      error.response?.data?.error ||
      error.response?.data?.message ||
      'An error occurred during the registration process.';
  }

  const customError: any = new Error(errorMessage);
  customError.status = error.response?.status;
  // Expose the full errors object so the UI can map individual field errors
  customError.fieldErrors = errorsObj || null;
  throw customError;
};
